import { Component, OnInit, Output, Input, OnChanges, SimpleChanges, AfterViewInit, EventEmitter } from '@angular/core';
import { ENV } from '@app/env';
import { ToastController, AlertController } from 'ionic-angular';
// import { StripeProvider } from '../../providers/stripe';
import { IUser } from '../../models/user.model';
import { Observable } from 'rxjs/Observable';
import { TranslateCodePipe } from '../../pipes/translate';

// declare var Stripe;

@Component({
  selector: 'app-card-form',
  template: `
  <form novalidate id="payment-form">
    <div class="form-row">
      <label for="card-element">
        Credit or debit card
      </label>
      <div id="card-element">
        <!-- A Stripe Element will be inserted here. -->
      </div>
      <!-- Used to display form errors. -->
      <div id="card-errors" role="alert"></div>
    </div>
    <div padding text-center margin-top>
      <button ion-button block type="submit" [color]="config.style_first_color" *ngIf="!submitAttemp">Save</button>
      <ion-spinner name="crescent" [color]="config.style_first_color" *ngIf="submitAttemp"></ion-spinner>
    </div>
  </form>
  `
})

export class CardFormComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() customer: any;
  @Input() user: IUser;
  @Input() config: any;
  @Output() cardAdded = new EventEmitter();

  public clientId = ENV.client;
  // private stripe = Stripe(ENV.stripe.api_key);
  public submitAttemp = false;

  constructor(
    // private stripeProvider: StripeProvider,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private translatePipe: TranslateCodePipe
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.initStripeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.customer) {
      this.customer = changes.customer.currentValue;
    }
    if (changes.user) {
      this.user = changes.user.currentValue;
    }
    if (changes.config) {
      this.config = changes.config.currentValue;
    }
  }

  /**
   * Config stripe elements and form/card callbacks
   * @author Jhonny Martínez
   */
  initStripeForm() {
    // Create an instance of Elements.
    // var elements = this.stripe.elements();

    // // Custom styling can be passed to options when creating an Element.
    // // (Note that this demo uses a wider set of styles than the guide below.)
    // var style = this.setStripeStyles();

    // // Create an instance of the card Element.
    // var card = elements.create('card', { style });

    // // Add an instance of the card Element into the `card-element` <div>.
    // card.mount('#card-element');

    // // Handle real-time validation errors from the card Element.
    // card.addEventListener('change', (event) => {
    //   var displayError = document.getElementById('card-errors');
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //   } else {
    //     displayError.textContent = '';
    //   }
    // });

    // // Handle form submission.
    // var form = document.getElementById('payment-form');
    // form.addEventListener('submit', (event) => {
    //   event.preventDefault();
    //   this.submitAttemp = true;

    //   this.stripe.createToken(card).then((result) => {
    //     // Check error
    //     if (result.error) {
    //       this.submitAttemp = false;
    //       // Inform the user if there was an error.
    //       var errorElement = document.getElementById('card-errors');
    //       errorElement.textContent = result.error.message;
    //     } else {
    //       let request;
    //       // Check current customer
    //       if (!this.customer) {
    //         request = this.createCustomer(result.token.id);
    //       } else {
    //         // Check customer account delete status
    //         if (this.customer.deleted) {
    //           request = this.createCustomer(result.token.id);
    //         } else {
    //           request = this.addCard(result.token.id);
    //         }
    //       }
    //       // Handle current request
    //       this.handleRequest(request);
    //     }
    //   });
    // });
  }

  /**
   * Build and return a create customer request, then save the customer id from server response
   * @param token id retrieved from stripe api
   * @author Jhonny Martínez
   */
  createCustomer(token: string) {
    // return this.stripeProvider.addCustomer(this.user.info.id, this.user.info.email, token)
    //   .switchMap((res: any) => {
    //     return Observable.fromPromise(this.stripeProvider.saveCustomerId(this.clientId, this.user.info.id, res.id))
    //       .map(() => res);
    //   });
  }

  /**
   * Build and return an add card request
   * @param token id retrieved from stripe api
   * @author Jhonny Martínez
   */
  addCard(token: string) {
    // return this.stripeProvider.addCard(this.customer.id, token);
  }

  /**
   * Initial stripe form styles
   * @author Jhonny Martínez
   */
  setStripeStyles() {
    return {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
  }

  /**
   * Handle success response or catch a bad response from the request
   * @param observable a request instance to be handled
   * @author Jhonny Martínez
   */
  handleRequest(observable: Observable<any>) {
    observable.catch(err => {
      this.submitAttemp = false;
      this.alertCtrl.create({
        title: 'Error',
        message: 'An error has ocurred in server',
        buttons: [
          { text: 'Ok', role: 'cancel' }
        ]
      }).present();
      return [];
    }).subscribe(res => {
      this.submitAttemp = false;
      this.presentToast('Card added successfully');
      this.cardAdded.emit(res);
    });
  }

  /**
   * Create and present toast with message
   * @param message toast message
   * @author Jhonny Martínez
   */
  async presentToast(message: string, position = 'bottom', duration = 3000) {
    this.toastCtrl.create({
      message: await this.translatePipe.transform(message),
      position,
      duration
    }).present();
  }

}


// WEBPACK FOOTER //
// ./src/components/card-form/card-form.component.ts